import "./LittleStar.css";

export default function LittleStar() {
  return <div className="star"></div>;
}
